import { cn } from '@/lib/cn'

const contentWidths = {
  xs: 'content-xs',
  sm: 'content-sm',
  md: 'content-md',
  lg: 'content-lg',
  xl: 'content-xl',
  full: 'content-full',
}

const contentAlignments = {
  start: 'self-start',
  center: 'self-center',
  end: 'self-end',
  stretch: 'auto-rows-auto',
}
const backgroundColors = {
  transparent: 'bg-transparent',
  theme: 'bg-theme',
  themeSignIn: 'bg-theme-signin',
  themeSignUp: 'bg-theme-signup',
  themeDark: 'bg-theme-dark',
  grey: 'bg-grey',
  white: 'bg-white',
}

const paddingYSizes = {
  none: 'py-0',
  xs: 'py-xs',
  sm: 'py-sm',
  md: 'py-md',
  lg: 'py-lg',
  xl: 'py-xl',
}

export default function Section({
  children,
  className,
  contentWidth = 'md',
  bg = 'transparent',
  py = 'md',
  contentAlign = 'start',
  fullHeight = false,
}: {
  children: React.ReactNode
  className?: string
  contentWidth?: keyof typeof contentWidths
  contentAlign?: keyof typeof contentAlignments
  bg?: keyof typeof backgroundColors
  py?: keyof typeof paddingYSizes
  fullHeight?: boolean
}) {
  return (
    <section
      className={cn(
        'section',
        backgroundColors[bg],
        contentWidths[contentWidth],
        paddingYSizes[py],
        fullHeight && 'full-height',
        className
      )}
    >
      <div
        className={cn(
          'section-content-wrapper',
          contentAlignments[contentAlign]
        )}
      >
        {children}
      </div>
    </section>
  )
}
